// https://docs.sentry.io/platforms/javascript/guides/nextjs/
//
// Sentry injects build-time values (release, tunnel route) into this module and adds it to the
// client entrypoint, so it has to exist even though helpers/observability.ts owns the actual
// client-side Sentry.init.

// oxlint-disable-next-line unicorn/require-module-specifiers -- keeps the file a module
;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.4";export {};
